import { Link } from "@/components/Link";

const LINK_CLASS =
  "hover:text-warmOrange-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warmOrange-500 focus-visible:ring-offset-2 rounded motion-reduce:transition-none";

/**
 * «الرئيسية» / «المدونة» / {title}. Mirrors the BreadcrumbList JSON-LD. Without a title (the /blog
 * index) «المدونة» is the current item. Plain navigation links: breadcrumbs are not a tracked CTA.
 */
export function BlogBreadcrumb({ title }: { title?: string }) {
  const separator = (
    <span aria-hidden="true" className="text-gray-300">
      /
    </span>
  );
  return (
    <nav aria-label="مسار الصفحة" className="mb-4 font-arabic">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-gray-500">
        <li>
          <Link to="/" className={LINK_CLASS}>
            الرئيسية
          </Link>
        </li>
        <li aria-hidden="true">{separator}</li>
        <li>
          {title ? (
            <Link to="/blog" className={LINK_CLASS}>
              المدونة
            </Link>
          ) : (
            <span aria-current="page" className="text-gray-900">
              المدونة
            </span>
          )}
        </li>
        {title && (
          <>
            <li aria-hidden="true">{separator}</li>
            <li className="min-w-0">
              <span aria-current="page" className="text-gray-900 truncate max-w-[60vw] md:max-w-none block">
                {title}
              </span>
            </li>
          </>
        )}
      </ol>
    </nav>
  );
}

export default BlogBreadcrumb;
